// extracted by mini-css-extract-plugin
module.exports = {"main":"SideMenuItems_main__X8KB-","title":"SideMenuItems_title__3y4u0","activeTitle":"SideMenuItems_activeTitle__ZUwHi"};